/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import BTable from "react-bootstrap/Table";
import Alert from "react-bootstrap/Alert";
import Form from "react-bootstrap/Form";
import "react-datetime/css/react-datetime.css";
import { useTable } from "react-table";
import "./Users.css";
import { httpClient } from "../../request";
import { statusToIcon } from "../../status";

/**
 * @todo Support pagination
 *
 * @param {*} param0
 */
function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  });

  // Render the UI for your table
  return (
    <BTable striped bordered hover size="sm" {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps()}>{column.render("Header")}</th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody>
        {rows.map((row, i) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell) => {
                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </BTable>
  );
}

function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PP", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}

export default function Files() {
  const [isLoading, setLoading] = useState(true);
  const [apps, setApps] = useState([]);
  const [appIDIndex, setAppIDIndex] = useState(-1);
  const [result, setResult] = useState(false);
  //const [upFile, setUpFile] = useState(null);

  const token = JSON.parse(localStorage.getItem("token"));

  const handleChangeAppID = (e) => {
    const { id, value } = e.target;
    setAppIDIndex(value);
  };

  const getApps = () => {
    httpClient
      .get("/private/apps", {
        headers: {
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        const responseData = response.data;

        let appsForId = responseData.apps;

        if (appsForId) {
          for (let i = 0; i < appsForId.length; ++i) {
            for (let j = 0; j < appsForId[i].Files.length; ++j) {
              appsForId[i].Files[j].app = appsForId[i].PublicId;
            }
          }

          setApps(appsForId);
        } else {
          setApps([]);
        }

        setLoading(false);
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });
  };

  const deleteFile = (filename, appID) => {
    httpClient
      .delete(`/private/files/${filename}?app=${appID}`, {
        headers: {
          Authorization: "Bearer " + token.token,
        },
      })
      .then((response) => {
        const responseData = response.data;

        if (responseData.status === true) {
          setResult({
            status: "success",
            message: `Deleted file ${filename}`,
          });

          getApps();
        } else {
          setResult({
            status: "danger",
            message: "An unknown error has occurred",
          });
        }
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });
  };

  const uploadFile = (upFile) => {
    let formData = new FormData();
    formData.append("file", upFile);

    httpClient
      .post(
        `/private/files/${upFile.name}?app=${apps[appIDIndex].PublicId}`,
        formData,
        {
          headers: {
            Authorization: "Bearer " + token.token,
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        const responseData = response.data;

        if (responseData.status === true) {
          setResult({
            status: "success",
            message: "Successfully uploaded file",
          });

          getApps();
        } else {
          setResult({
            status: "danger",
            message: "An unknown error has occurred",
          });
        }
      })
      .catch((error) => {
        // The error has response, it likely has an error message from the API
        if (error.response) {
          const responseData = error.response.data;
          if ("error" in responseData) {
            /* Additionally clear the input fields if we fail to login. The form will still show the text, but the email and password state values will be
             * empty, leading to a confusing error due to the app not sending any credentials in a subsequent request
             */
            setResult({
              status: "danger",
              message: responseData.error,
            });
          }
        } else {
          // Catch edge cases, usually happens with network errors
          setResult({
            status: "danger",
            message: error.message,
          });
        }
      });
  };

  const handleFileChange = (e) => {
    setResult({
      status: "info",
      message: "Uploading file..."
    });

    uploadFile(e.target.files[0]);
  };

  // useEffect tells the component that it must do something after it has rendered
  useEffect(() => getApps(), []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Files",
        columns: [
          {
            Header: "Filename",
            accessor: "Name",
          },
          {
            Header: "File Size",
            accessor: (d) => {
              return formatBytes(d.Size);
            },
          },
          {
            id: "del",
            Header: "",
            accessor: (d) => {
              return d;
            },
            Cell: ({ value }) => (
              <Button
                variant="danger"
                onClick={() => {
                  if (
                    window.confirm("Are you sure you want to delete this file?")
                  )
                    deleteFile(value.Name, value.app);
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            ),
          },
        ],
      },
    ],
    []
  );

  return (
    <div className="Users">
      <div className="mt-5">
        {result && (
          <Alert variant={result.status}>
            <span className="mr-1">
              <FontAwesomeIcon icon={statusToIcon[result.status]} />
            </span>
            <span>{result.message}</span>
          </Alert>
        )}

        {isLoading ? (
          <div>Loading...</div>
        ) : (
          <div>
            <Form>
              <Form.Group controlId="appID">
                <Form.Label>App ID</Form.Label>
                <Form.Control
                  as="select"
                  onChange={handleChangeAppID}
                  defaultValue={`DEFAULT`}
                >
                  <option value="DEFAULT" disabled>
                    Select an app ID...
                  </option>
                  {apps.map((c, i) => {
                    // @todo: Try simplifying expression
                    return (
                      <option key={c.PublicId} value={i}>
                        {c.PublicId}
                      </option>
                    );
                  })}
                </Form.Control>
                <small className="form-text text-muted">
                  Select an app to show its files
                </small>
              </Form.Group>
            </Form>

            <div>
              {appIDIndex >= 0 && (
                <div>
                  <Table columns={columns} data={apps[appIDIndex].Files} />
                  {apps[appIDIndex].Files.length === 0 && (
                    <p className="text-center">No data available</p>
                  )}

                  <div className="float-right">
                    <Form.Group>
                      <Form.File
                        id="file"
                        label="Upload"
                        onChange={handleFileChange}
                      />
                    </Form.Group>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/containers/dashboard/Files.js